<template>
  <!--  style="width:608px;"-->
  <div class="top-menu" :style="{ width: navStyleWidth }">
    <ul class="menu-list" :style="containerStyle">
      <li
        class="menu-list-item"
        v-for="item in menuList"
        :key="item.module_int"
        :class="{ selected: item.selected }"
        @click="menuItemClick({ key: item.module_int + '' })"
      >
        <!--首页-->
        <div v-if="item.module_int == '/home'" class="m-home">
          <img
            src="~@/assets/img/menu/icon_home.svg"
            class="menu-icon"
            v-show="!item.selected"
          />
          <img
            src="~@/assets/img/menu/icon_home_highlight.svg"
            class="menu-icon"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_home.svg"
            class="menu-text"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_home_default.svg"
            class="menu-text"
            v-show="!item.selected"
          />
          <!--          <a-icon :component="IconMenuHome" :style="iconStyle" />-->
          <!--          <a-icon-->
          <!--            :component="TextMenuHome"-->
          <!--            class="menu-text"-->
          <!--            :style="textStyle"-->
          <!--          />-->
        </div>
        <!--辖区管理-->
        <div v-if="item.module_int == '1000000'" class="m-manage">
          <img
            src="~@/assets/img/menu/icon_manage.svg"
            class="menu-icon"
            v-show="!item.selected"
          />
          <img
            src="~@/assets/img/menu/icon_manage_highlight.svg"
            class="menu-icon"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_manage.svg"
            class="menu-text"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_manage_default.svg"
            class="menu-text"
            v-show="!item.selected"
          />
          <!--          <a-icon :component="IconMenuManage" :style="iconStyle" />-->
          <!--          <a-icon-->
          <!--            :component="TextMenuManage"-->
          <!--            class="menu-text"-->
          <!--            :style="textStyle"-->
          <!--          />-->
        </div>
        <!--主数据-->
        <div v-if="item.module_int == '2000000'" class="m-data">
          <img
            src="~@/assets/img/menu/icon_data.svg"
            class="menu-icon"
            v-show="!item.selected"
          />
          <img
            src="~@/assets/img/menu/icon_data_highlight.svg"
            class="menu-icon"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_data.svg"
            class="menu-text"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_data_default.svg"
            class="menu-text"
            v-show="!item.selected"
          />
          <!--          <a-icon :component="IconMenuData" :style="iconStyle" />-->
          <!--          <a-icon-->
          <!--            :component="TextMenuData"-->
          <!--            class="menu-text"-->
          <!--            :style="textStyle"-->
          <!--          />-->
        </div>
        <!--流向-->
        <div v-if="item.module_int == '4000000'" class="m-flow">
          <img
            src="~@/assets/img/menu/icon_flow.svg"
            class="menu-icon"
            v-show="!item.selected"
          />
          <img
            src="~@/assets/img/menu/icon_flow_highlight.svg"
            class="menu-icon"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_flow.svg"
            class="menu-text"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_flow_default.svg"
            class="menu-text"
            v-show="!item.selected"
          />
          <!--          <a-icon :component="IconMenuFlow" :style="iconStyle" />-->
          <!--          <a-icon-->
          <!--            :component="TextMenuFlow"-->
          <!--            class="menu-text"-->
          <!--            :style="textStyle"-->
          <!--          />-->
        </div>
        <!--奖金-->
        <div v-if="item.module_int == '9000000'" class="m-flow">
          <img
            src="~@/assets/img/menu/icon_bonus.svg"
            class="menu-icon"
            v-show="!item.selected"
          />
          <img
            src="~@/assets/img/menu/icon_bonus_highlight.svg"
            class="menu-icon"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_bonus.svg"
            class="menu-text"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_bonus_default.svg"
            class="menu-text"
            v-show="!item.selected"
          />
          <!--          <a-icon :component="IconMenuFlow" :style="iconStyle" />-->
          <!--          <a-icon-->
          <!--            :component="TextMenuFlow"-->
          <!--            class="menu-text"-->
          <!--            :style="textStyle"-->
          <!--          />-->
        </div>
        <!--行为管理-->
        <div v-if="item.module_int == '3000000'" class="m-manage">
          <img
            src="~@/assets/img/menu/icon_s2p.svg"
            class="menu-icon"
            v-show="!item.selected"
          />
          <img
            src="~@/assets/img/menu/icon_s2p_highlight.svg"
            class="menu-icon"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_s2p_highlight.svg"
            class="menu-text"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_s2p_default.svg"
            class="menu-text"
            v-show="!item.selected"
          />
        </div>
        <!--对接系统-->
        <div v-if="item.module_int == '1300000'" class="m-manage">
          <img
            src="~@/assets/img/menu/icon_docking.svg"
            class="menu-icon"
            v-show="!item.selected"
          />
          <img
            src="~@/assets/img/menu/icon_docking_highlight.svg"
            class="menu-icon"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_docking.svg"
            class="menu-text"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_docking_default.svg"
            class="menu-text"
            v-show="!item.selected"
          />
        </div>
        <!--学习平台-->
        <div v-if="item.module_int == '12000000'" class="m-manage">
          <img
            src="~@/assets/img/menu/icon_study.svg"
            class="menu-icon"
            v-show="!item.selected"
          />
          <img
            src="~@/assets/img/menu/icon_study_highlight.svg"
            class="menu-icon"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_study.svg"
            class="menu-text"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_study_default.svg"
            class="menu-text"
            v-show="!item.selected"
          />
        </div>
        <!--商务订单-->
        <div v-if="item.module_int == '6000000'" class="m-manage">
          <img
            src="~@/assets/img/menu/icon_order.svg"
            class="menu-icon"
            v-show="!item.selected"
          />
          <img
            src="~@/assets/img/menu/icon_order_highlight.svg"
            class="menu-icon"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/icon_order_management_white.svg"
            class="menu-text"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/icon_order_management_grey.svg"
            class="menu-text"
            v-show="!item.selected"
          />
        </div>
        <!--TODO:20200730云拜访不发-->
        <div v-if="item.module_int == '1400000'" class="m-manage">
          <img
            src="~@/assets/img/menu/icon_cloud_visit_defalut.svg"
            class="menu-icon"
            v-show="!item.selected"
          />
          <img
            src="~@/assets/img/menu/icon_cloud_visit.svg"
            class="menu-icon"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_cloud_visit.svg"
            class="menu-text"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_cloud_visit_defalut.svg"
            class="menu-text"
            v-show="!item.selected"
          />
        </div>
        <!--芒哥-->
        <div v-if="item.module_int == '10000000'" class="m-manage">
          <img
            src="~@/assets/img/menu/icon_mango.svg"
            class="menu-icon"
            v-show="!item.selected"
          />
          <img
            src="~@/assets/img/menu/icon_mango_highlight.svg"
            class="menu-icon"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_mango.svg"
            class="menu-text"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_mango_default.svg"
            class="menu-text"
            v-show="!item.selected"
          />
        </div>
        <!--智能报表-->
        <div v-if="item.module_int == '1500000'" class="m-manage">
          <img
            src="~@/assets/img/menu/icon_smart_report.svg"
            class="menu-icon"
            v-show="!item.selected"
          />
          <img
            src="~@/assets/img/menu/icon_smart_report_highlight.svg"
            class="menu-icon"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_smart_report.svg"
            class="menu-text"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_smart_report_default.svg"
            class="menu-text"
            v-show="!item.selected"
          />
        </div>
        <!--费控系统-->
        <div v-if="item.module_int == '1600000'" class="m-manage">
          <img
            src="~@/assets/img/menu/icon_cost_control_default.svg"
            class="menu-icon"
            v-show="!item.selected"
          />

          <img
            src="~@/assets/img/menu/icon_cost_control_highlight.svg"
            class="menu-icon"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_cost_control_default.svg"
            class="menu-text"
            v-show="!item.selected"
          />
          <img
            src="~@/assets/img/menu/word_cost_control_highlight.svg"
            class="menu-text"
            v-show="item.selected"
          />
        </div>
        <!--协议管理系统-->
        <div v-if="item.module_int === '1700000'" class="m-manage">
          <img
            src="~@/assets/img/menu/icon_annual_agreement_default.svg"
            class="menu-icon"
            v-show="!item.selected"
          />

          <img
            src="~@/assets/img/menu/icon_annual_agreement_highlight.svg"
            class="menu-icon"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_annual_agreement_default.svg"
            class="menu-text"
            v-show="!item.selected"
          />
          <img
            src="~@/assets/img/menu/word_annual_agreement_highlight.svg"
            class="menu-text"
            v-show="item.selected"
          />
        </div>
        <!--预警管理-->
        <div v-if="item.module_int === '18000000'" class="m-manage">
          <img
            src="~@/assets/img/menu/icon_early_warning_default.svg"
            class="menu-icon"
            v-show="!item.selected"
          />

          <img
            src="~@/assets/img/menu/icon_early_warning_highlight.svg"
            class="menu-icon"
            v-show="item.selected"
          />
          <img
            src="~@/assets/img/menu/word_early_warning_default.svg"
            class="menu-text"
            v-show="!item.selected"
          />
          <img
            src="~@/assets/img/menu/word_early_warning_highlight.svg"
            class="menu-text"
            v-show="item.selected"
          />
        </div>
      </li>
    </ul>
    <div class="custom-arrow-left" @click="prev" v-if="is_arrows">
      <a-icon type="left" class="arrow-icon" />
    </div>
    <div class="custom-arrow-right" @click="next" v-if="is_arrows">
      <a-icon type="right" class="arrow-icon" />
    </div>
  </div>
</template>

<script>
import {
  IconMenuHome,
  TextMenuHome,
  IconMenuManage,
  TextMenuManage,
  IconMenuData,
  TextMenuData,
  IconMenuFlow,
  TextMenuFlow
} from '@/utils/svgImgs'
export default {
  name: 'TopMenu',
  props: {
    menuList: Array,
    selectedKeys: Array
  },
  beforeCreate() {},
  data: () => ({
    IconMenuHome,
    TextMenuHome,
    IconMenuManage,
    TextMenuManage,
    IconMenuData,
    TextMenuData,
    IconMenuFlow,
    TextMenuFlow,
    iconStyle: { marginRight: '12px', fontSize: '38px' },
    textStyle: { fontSize: '36px' },
    screenWidth: document.documentElement.clientWidth,

    sumWidth: '',
    rightWidth: '',
    leftWidth: '',
    result: '',
    ulWidth: '',
    number: '',
    menuWidth: '',
    distance: 0,
    is_arrows: true,
    navStyleWidth: '',
    navOverallWidth: '',
    navUlWidth: ''
  }),
  computed: {
    containerStyle() {
      return {
        transform: `translate3d(${this.distance}px, 0, 0)`,
        width: `${this.navOverallWidth}px`
      }
    }
  },
  watch: {
    selectedKeys: {
      immediate: true,
      handler(n, o) {
        this.filterSelected()
      }
    }
  },
  created() {
    console.log(this.menuList, 'menuList========>')
  },
  mounted() {
    let that = this
    // this.getShowNumber(700,5);
    setTimeout(() => {
      //获取导航显示宽度
      that.navWidth = document.getElementsByClassName('top-menu')[0].clientWidth
      //获取导航总宽度
      that.navUlWidth =
        document.getElementsByClassName('menu-list')[0].clientWidth + 48
      //动态计算 计算可移动宽度
      that.mayMoveWidth = that.navUlWidth - that.navWidth
    }, 500)
  },

  methods: {
    getShowNumber(tempNavWidth, length) {
      // console.log(tempNavWidth);
      // console.log(length)
      if (Math.round(tempNavWidth / 140) >= length) {
        this.is_arrows = false
      } else {
        this.is_arrows = true
      }
      //更具数据 计算导航总宽度
      this.navOverallWidth = 140 * length
      //先这是导航显示宽度
      let tempNavW = ''
      if (Math.round(tempNavWidth / 140) * 140 < 140) {
        tempNavW = 140
      } else {
        tempNavW = Math.round(tempNavWidth / 140) * 140
        // tempNavW = length * 140;
      }
      this.navStyleWidth = tempNavW + 48 + 'px'
      //获取导航显示宽度
      this.navWidth = Math.round(tempNavWidth / 140) * 140 + 48
      //获取导航总宽度
      this.navUlWidth =
        document.getElementsByClassName('menu-list')[0].clientWidth + 48
      //动态计算 计算可移动宽度
      this.mayMoveWidth = this.navUlWidth - this.navWidth
      //变宽时候自动补上移动的距离
      if (
        this.prevMayMoveWidth > this.navUlWidth - this.navWidth &&
        Math.abs(this.distance) == this.prevMayMoveWidth
      ) {
        if (this.distance != 0) {
          this.distance += 140
        }
      }
      //上一次的可移动宽度
      this.prevMayMoveWidth = this.navUlWidth - this.navWidth
    },
    filterSelected() {
      console.log(this.selectedKeys, 'selectedKeys')
      for (let i = 0, len = this.menuList.length; i < len; i++) {
        this.menuList[i].selected =
          this.selectedKeys.indexOf(this.menuList[i].module_int + '') > -1
        this.$set(this.menuList, i, this.menuList[i])
      }
      this.ulWidth = this.menuList.length * 175
    },
    menuItemClick(e) {
      this.$emit('click', e)
    },
    prev() {
      let tempDistance = this.distance
      if ((tempDistance += 140 <= 0)) {
        this.distance += 140
      }
    },
    next() {
      let tempDistance = this.distance
      if (Math.abs((tempDistance += -140)) <= this.mayMoveWidth + 140) {
        this.distance += -140
      }
      // console.log(this.distance)
    }
  }
}
</script>

<style scoped lang="less">
@arrowWidth: 24px;
.top-menu {
  position: relative;
  padding: 0 @arrowWidth;
  overflow: hidden;
  /*width: 100%;*/
  /*height: 100%;*/
}
.arrow {
  /*TODO:*/
  /*display: none;*/
  position: absolute;
  top: 0;
  width: @arrowWidth;
  height: 100%;
  cursor: pointer;
  &.left {
    left: 0;
    background: linear-gradient(to left, #2a3139 0%, #2a3139 10%, #1e2329 100%);
  }
  &.right {
    right: 0;
    background: linear-gradient(
      to right,
      #2a3139 0%,
      #2a3139 10%,
      #1e2329 100%
    );
  }
  .arrow-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.menu-list {
  margin: 0;
  height: 100%;
  transition: transform 0.5s;
  white-space: nowrap;
  word-break: break-all;
  &:after {
    display: table;
    content: '';
    clear: both;
  }
  .menu-list-item {
    /*margin: 0 26px;*/
    height: 100%;
    line-height: 70px;
    /*float: left;*/
    width: 140px;
    cursor: pointer;
    transition: all 1s;
    display: inline-block;
    .menu-icon {
      margin-right: 16px;
      /*color: #51565d;*/
    }
    .menu-text {
      color: rgba(255, 255, 255, 0.65);
    }
    &.selected {
      .m-home {
        color: #1dba52;
      }
      .m-manage {
        color: #0799ff;
      }
      .m-data {
        color: #c564ff;
      }
      .m-flow {
        color: #6464ff;
      }
      .menu-text {
        color: #fff !important;
      }
    }
  }
}
.m-width {
  width: 660px;
}
.swiper-slide {
  /*width: auto !important;*/
}
.custom-arrow-right,
.custom-arrow-left {
  width: 24px;
  height: 100%;
  position: absolute;
  top: 0px;
  right: 0px;
  outline: none;
  background: linear-gradient(to right, #2a3139 0%, #2a3139 10%, #1e2329 100%);
}
.custom-arrow-left {
  left: 0px;
  background: linear-gradient(to left, #2a3139 0%, #2a3139 10%, #1e2329 100%);
}
.arrow-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
